import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowUp } from 'react-icons/fa';
import './StayWithUs.css';

const BackgroundImage = '/static/media/Strip-2.563efaee40f6d40523f2.jpg';

const StayWithUs = () => {
  return (
    <div className="stay-with-section" style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className="stay-with-content">
        <h2 className="stay-title">Step Into Quality, Step Into Success</h2>
        <Link to="/dealer">
          <button className="stay-button">
            Become a Dealer
            <span className="stay-button-circle">
              <FaArrowUp style={{ color: '#fff', fontSize: '12px', transform: 'rotate(45deg)' }} />
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default StayWithUs;
